import { render, staticRenderFns } from "./CameraUpdateDialog.vue?vue&type=template&id=24e286fe&scoped=true"
import script from "./CameraUpdateDialog.vue?vue&type=script&lang=js"
export * from "./CameraUpdateDialog.vue?vue&type=script&lang=js"
import style0 from "./CameraUpdateDialog.vue?vue&type=style&index=0&id=24e286fe&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e286fe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24e286fe')) {
      api.createRecord('24e286fe', component.options)
    } else {
      api.reload('24e286fe', component.options)
    }
    module.hot.accept("./CameraUpdateDialog.vue?vue&type=template&id=24e286fe&scoped=true", function () {
      api.rerender('24e286fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/schoolconfig/camera/CameraUpdateDialog.vue"
export default component.exports